import React, { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { servicesData } from "../constant/data";

const ServiceIcon = ({ title, className = "w-7 h-7" }) => {
  const t = title.toLowerCase();
  const stroke = "url(#auroraStroke)";

  const Defs = (
    <defs>
      <linearGradient id="auroraStroke" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#5eead4" />
        <stop offset="60%" stopColor="#ec4899" />
        <stop offset="100%" stopColor="#fbbf24" />
      </linearGradient>
    </defs>
  );

  if (t.includes("e-commerce") || t.includes("ecommerce") || t.includes("commerce")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <path
          d="M3 4h2.2l2 11.2A2 2 0 0 0 9.18 17h8.66A2 2 0 0 0 19.82 15.4L21 8H6"
          stroke={stroke}
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="9" cy="20" r="1.4" stroke={stroke} strokeWidth="1.6" />
        <circle cx="17" cy="20" r="1.4" stroke={stroke} strokeWidth="1.6" />
      </svg>
    );
  }
  if (t.includes("api") || t.includes("integration")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <circle cx="6" cy="12" r="2.6" stroke={stroke} strokeWidth="1.7" />
        <circle cx="18" cy="6" r="2.6" stroke={stroke} strokeWidth="1.7" />
        <circle cx="18" cy="18" r="2.6" stroke={stroke} strokeWidth="1.7" />
        <path
          d="M8.4 11l7.2-3.5M8.4 13l7.2 3.5"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (t.includes("ui") || t.includes("ux") || t.includes("design")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <path
          d="M14.7 4.3l5 5L9 20H4v-5L14.7 4.3z"
          stroke={stroke}
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path d="M13 6l5 5" stroke={stroke} strokeWidth="1.6" />
      </svg>
    );
  }
  if (t.includes("deploy") || t.includes("store") || t.includes("publish")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <path
          d="M12 3v11M7.5 9.5L12 14l4.5-4.5"
          stroke={stroke}
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 17.5V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1.5"
          stroke={stroke}
          strokeWidth="1.7"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (t.includes("maint") || t.includes("support") || t.includes("optim")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <path
          d="M14.5 4.6a4.5 4.5 0 0 0-5.85 5.85L4 15.1l4.9 4.9 4.65-4.65a4.5 4.5 0 0 0 5.85-5.85l-2.95 2.95-2.65-.7-.7-2.65L14.5 4.6z"
          stroke={stroke}
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  if (t.includes("responsive")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <rect x="2.5" y="5.5" width="13" height="10" rx="1.5" stroke={stroke} strokeWidth="1.7" />
        <rect x="14" y="9.5" width="7.5" height="11" rx="1.5" stroke={stroke} strokeWidth="1.7" />
        <path d="M5 18h6" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    );
  }
  if (t.includes("progressive") || t.includes("pwa")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <circle cx="12" cy="12" r="8.5" stroke={stroke} strokeWidth="1.7" />
        <path
          d="M3.5 12h17M12 3.5c2.6 3 2.6 14 0 17M12 3.5c-2.6 3-2.6 14 0 17"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  if (t.includes("native") || t.includes("mobile") || t.includes("cross")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <rect x="6.5" y="2.5" width="11" height="19" rx="2.5" stroke={stroke} strokeWidth="1.7" />
        <path d="M10.5 18.5h3" stroke={stroke} strokeWidth="1.7" strokeLinecap="round" />
        <circle cx="12" cy="11.5" r="2.4" stroke={stroke} strokeWidth="1.7" />
      </svg>
    );
  }
  if (t.includes("web")) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        {Defs}
        <rect x="2.5" y="3.5" width="19" height="14" rx="2" stroke={stroke} strokeWidth="1.7" />
        <path d="M2.5 8h19" stroke={stroke} strokeWidth="1.7" />
        <circle cx="5.5" cy="5.75" r="0.7" fill={stroke} />
        <circle cx="7.7" cy="5.75" r="0.7" fill={stroke} />
        <path d="M9 21h6M12 17.5v3.5" stroke={stroke} strokeWidth="1.7" strokeLinecap="round" />
        <path
          d="M7.5 12.5l2 1.8-2 1.7M11 16h3.2"
          stroke={stroke}
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  // full-stack / default — stacked DB
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
      {Defs}
      <ellipse cx="12" cy="5" rx="7.5" ry="2.4" stroke={stroke} strokeWidth="1.7" />
      <path d="M4.5 5v6c0 1.32 3.36 2.4 7.5 2.4s7.5-1.08 7.5-2.4V5" stroke={stroke} strokeWidth="1.7" />
      <path d="M4.5 11v6c0 1.32 3.36 2.4 7.5 2.4s7.5-1.08 7.5-2.4v-6" stroke={stroke} strokeWidth="1.7" />
    </svg>
  );
};

function ServiceCard({ s, idx, isExtra = false }) {
  const cardRef = useRef(null);
  const handleMove = (e) => {
    const el = cardRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - r.left}px`);
    el.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  const col = idx % 3;
  const fromX = col === 0 ? -60 : col === 2 ? 60 : 0;
  const fromY = col === 1 ? 40 : 0;
  const initial = isExtra
    ? { opacity: 0, y: 16, scale: 0.96 }
    : { opacity: 0, x: fromX, y: fromY };
  const animate = isExtra ? { opacity: 1, y: 0, scale: 1 } : undefined;
  const whileInView = isExtra ? undefined : { opacity: 1, x: 0, y: 0 };

  return (
    <motion.div
      ref={cardRef}
      onMouseMove={handleMove}
      initial={initial}
      animate={animate}
      whileInView={whileInView}
      exit={isExtra ? { opacity: 0, y: 12, scale: 0.97 } : undefined}
      viewport={isExtra ? undefined : { once: true, margin: "-60px" }}
      transition={{
        duration: 0.7,
        delay: isExtra ? idx * 0.05 : 0.05 + col * 0.05,
        ease: [0.22, 1, 0.36, 1],
      }}
      layout
      className="group relative rounded-2xl border border-white/10 p-6 md:p-7 overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.01) 100%)",
      }}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
        style={{
          background:
            "radial-gradient(420px circle at var(--mx,50%) var(--my,50%), rgba(45,212,191,0.22), transparent 40%)",
        }}
      />

      <div className="relative">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-aurora-teal/15 to-aurora-magenta/15 border border-white/10 mb-5">
          <ServiceIcon title={s.title} className="w-6 h-6" />
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-white">{s.title}</h3>
        <p className="mt-2 text-sm text-white/60 leading-relaxed">
          {s.description}
        </p>

        <div className="mt-6 flex items-center text-xs text-white/50 group-hover:text-aurora-teal transition-colors">
          <span>Learn more</span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            className="ml-2 transition-transform group-hover:translate-x-1"
          >
            <path
              d="M5 12h14M13 5l7 7-7 7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      <div className="absolute -bottom-px left-6 right-6 h-px bg-gradient-to-r from-transparent via-aurora-teal/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
    </motion.div>
  );
}

const Section4 = ({ showAll = false }) => {
  const [expanded, setExpanded] = useState(showAll);

  const baseServices = servicesData.slice(0, 3);
  const extraServices = servicesData.slice(3);

  return (
    <>
      {/* Services */}
      <section
        id="services"
        className="relative w-full px-6 md:px-12 lg:px-24 pt-16 md:pt-20 pb-20 md:pb-24 overflow-hidden"
      >
        <div className="absolute top-1/2 left-0 -translate-y-1/2 w-[400px] h-[400px] bg-aurora-magenta/10 blur-[120px] rounded-full pointer-events-none" />
        <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-aurora-amber/5 blur-[120px] rounded-full pointer-events-none" />

        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="eyebrow">
              <span className="dot" />
              Services
            </span>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              className="mt-5 font-jamjuree text-3xl md:text-5xl font-semibold text-white leading-tight"
            >
              What we <span className="text-gradient-aurora">build</span>.
            </motion.h2>
          </div>

          <motion.div
            layout
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
          >
            {baseServices.map((s, i) => (
              <ServiceCard key={s.id} s={s} idx={i} />
            ))}

            <AnimatePresence>
              {expanded &&
                extraServices.map((s, i) => (
                  <ServiceCard key={s.id} s={s} idx={i} isExtra />
                ))}
            </AnimatePresence>
          </motion.div>

          <div className="mt-12 flex justify-center">
            {!showAll && (
            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              className="btn-ghost"
              aria-expanded={expanded}
            >
              {expanded ? "Show less" : `Explore all services (${servicesData.length})`}
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                className={`transition-transform ${expanded ? "rotate-180" : ""}`}
              >
                <path
                  d="M6 9l6 6 6-6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
          </div>
        </div>
      </section>

      {/* Why choose me */}
    </>
  );
};

export default Section4;
